module.exports = __webpack_public_path__ + "static/img/banSc.7cdcfa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banSc.jpg
// module id = 7GSt
// module chunks = 1